<template>
    <div>
        <NavBar></NavBar>
        <h1> PANTALLA DE MONITOREO GPS</h1>
    </div>
</template>

<script>
import NavBar from '../../../components/NavBar.vue'
export default {
    name: 'LecturaInspeccion',

    components:{
        'NavBar': NavBar
    },
}
</script>